import NodePreview from './NodePreview';
import StartInactiveBrowser from './StartInactiveBrowser';
import GenericMediaItem from './GenericMediaItem';
import Movie from './Movie';
import Weather from './Weather';
import SlideShow from './SlideShow';
import TVApp from './TVApp';
import GenericQRCaster from './GenericQRCaster';
import MediaGrid from './MediaGrid';
import Radio from './Radio';
import RemoteSiteLauncher from './RemoteSiteLauncher';
import RSS from './RSS';
import ChildLock from './ChildLock';
import ServiceCall from './ServiceCall';

export class NodeApplication {
    func?: { id: number, label: string };
    startInactiveBrowser = new StartInactiveBrowser();
    weatherLocation = new Weather();
    genericMediaItem = new GenericMediaItem();
    genericQRCaster = new GenericQRCaster();
    movie = new Movie(0, 0);
    serviceCall = new ServiceCall();
    // serviceCall = new RemoteSiteLauncher(true);
    slideShow = new SlideShow();
    tvApp = new TVApp();
    mediaGrid = new MediaGrid();
    radio = new Radio();
    remoteSiteLauncher = new RemoteSiteLauncher(false);
    Rss = new RSS();
    //childLock = new ChildLock();
}

export class NodeLinkedMenu {
    infoPageId?: number;
    infoPageLanguageId?: number;
    tvMenuId?: number;
}

export class NodeInfo {
    htmlContent: string = '';
}

export class Node {
    nodeType = 'Info';
    preview = new NodePreview();
    nodeApplication = new NodeApplication();
    nodeLinkedMenu = new NodeLinkedMenu();
    nodeInfo = new NodeInfo();
}

export default Node;
